const packageInfo = require('../../package.json');

export default function getAppVersion() {
  return packageInfo
    .version
    .split('.')
    .slice(0, 2)
    .join('.');
}